import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import LoginPage from '../../../pages/LoginPage/LoginPage';

export default function LoginWithReCaptcha() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LepGjAnAAAAAKTvGffqMzdbdak838n5bKC-vy-n">
        <LoginPage />
    </GoogleReCaptchaProvider>
  )
}

